export const SET_JOB_DES_DATA = 'SET_JOB_DES_DATA';
export const RESET_INTERVIEW_REVIEW_DATA = 'RESET_INTERVIEW_REVIEW_DATA';
export const SET_OVERALL_REVIEW_DATA = 'SET_OVERALL_REVIEW_DATA';
export const SET_ALL_QNA_DATA = 'SET_ALL_QNA_DATA';
export const SET_INTERVIEW_REVIEW_DATA = 'SET_INTERVIEW_REVIEW_DATA';
export const SET_ANS = 'SET_ANS';
